module.exports = __webpack_public_path__ + "img/non_concrete_porch_veranda_roof_attached.447676f8.jpg";